export enum UserAction {
  CREATE = 'create',
  UPDATE = 'update',
  VIEW = 'view',

  CHANGE_ROLE = 'change-role',
  CHANGE_STATUS = 'change-status',
  CHANGE_STATUS_SUPER_ADMIN = 'change-status-super-admin',
  CHANGE_PHONE_NUMBER_RANGE = 'change-phone-number-range',
  EDIT_MOBILE_PROVISIONING_DETAILS = 'edit-mobile-provisioning-details',
  TRANSFER_ORDER_LINES_TO_CUSTOMER = 'transfer-order-lines-to-customer',
  REFRESH_PROVISIONING_PORTING_DATE = 'refresh-provisioning-porting-date',
  RETRY_MOBILE_ORDER_PROVISIONING = 'retry-mobile-order-provisioning',
  CANCEL_MOBILE_ORDER_PROVISIONING = 'cancel-mobile-order-provisioning',
  CHANGE_PHONE_NUMBER = 'change-phone-number',
  CANCEL = 'cancel',
  CHANGE_MSISDN = 'change-msisdn',

  DOWNLOAD = 'download',
  PARTNER_LOGIN = 'partner-login',
  PROVISION = 'provision',
  TERMINATE = 'terminate',
}
